/* eslint-disable no-restricted-imports */
import React, { useEffect } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { useEventContext } from "./EventDataContext";

export function EventFullDialog({
  history,
  id,
  show,
  onHide,
  setFullSuccessOpen,
  setFullErrorOpen,
}) {
  const context = useEventContext();
  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
  }, [id]);

  const fullEvent = async () => {
    const fullEventUrl = "api/workshops/full/";
    const result = await axios.patch(fullEventUrl + id);
    if (result.data === "success") {
      setFullSuccessOpen(true);
      context.setRefetch(true);
      setTimeout(() => {
        history.push("/events/event-list");
      }, 1000);
    } else {
      setFullErrorOpen(true);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {/* {isLoading && <ModalProgressBar variant="query" />} */}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">Event Full</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span>Are you sure you want to mark this event as full?</span>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={fullEvent}
            className="btn btn-delete btn-elevate"
          >
            Mark Full
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
